import React from "react";
import { Tooltip } from "antd";
import { CalculatorOutlined, WarningFilled } from "@ant-design/icons";
import dineroDisabledMask from "../../../../../Components/dineroDisabledMask";
import EtiquetaMoneda from "../../../../../Components/EtiquetaMoneda";

// Una lista de precios del insumo. La cifra grande es el precio CONFIGURADO (precios[].precio);
// debajo, en chico, el precio que saldria con el costo de hoy y el margen objetivo. Cuando los
// dos no coinciden se marca, porque significa que el precio guardado quedo viejo respecto al
// costo actual.
//
// "Usar" devuelve el precio SIN impuestos: es lo que espera precioUnitario en el renglon.
const TarjetaPrecio = ({
  fila,
  moneda,
  enCalculadora,
  esListaDelDocumento,
  onUsar,
  onCargarSugerido,
}) => {
  const {
    nombre,
    configurado,
    netoConfigurado,
    porcentajeConfigurado,
    porcentajeObjetivo,
    sugerido,
    netoSugerido,
    diferencia,
    desfasado,
  } = fila;

  const sinConfigurar = configurado == null;
  const precioPrincipal = sinConfigurar ? sugerido : configurado;
  const netoPrincipal = sinConfigurar ? netoSugerido : netoConfigurado;
  const porcentajeBadge = sinConfigurar ? porcentajeObjetivo : porcentajeConfigurado;

  return (
    <div
      style={{
        flex: "1 1 210px",
        minWidth: 210,
        maxWidth: 300,
        border: `1px solid ${enCalculadora ? "#00BFD6" : "#e5e7eb"}`,
        borderRadius: 8,
        overflow: "hidden",
        background: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 6,
          padding: "6px 10px",
          background: enCalculadora ? "#00BFD615" : "#fafafa",
          borderBottom: "1px solid #f3f4f6",
        }}
      >
        <span
          style={{
            fontSize: 12,
            fontWeight: 700,
            color: "#374151",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {nombre}
        </span>
        <span style={{ display: "flex", alignItems: "center", gap: 4, flexShrink: 0 }}>
          {porcentajeBadge != null && (
            <span
              style={{
                fontSize: 11,
                fontWeight: 600,
                color: "#00BFD6",
                background: "#00BFD615",
                borderRadius: 4,
                padding: "1px 6px",
              }}
            >
              {porcentajeBadge}%
            </span>
          )}
          {desfasado && (
            <Tooltip
              title={`El precio guardado no corresponde al costo actual (${
                diferencia > 0 ? "+" : ""
              }${dineroDisabledMask(diferencia)} contra el sugerido)`}
            >
              <WarningFilled style={{ color: "#b45309", fontSize: 12 }} />
            </Tooltip>
          )}
        </span>
      </div>

      <div style={{ padding: "10px 10px 8px 10px", flex: 1 }}>
        {esListaDelDocumento && (
          <div
            style={{
              fontSize: 10,
              fontWeight: 600,
              color: "#00BFD6",
              textTransform: "uppercase",
              letterSpacing: "0.04em",
              marginBottom: 2,
            }}
          >
            Lista del documento
          </div>
        )}
        {/* La moneda va solo en la cifra grande: el `neto` y el `s/costo` de abajo son de la
            misma tarjeta y por lo tanto de la misma moneda, repetirla ahi solo mete ruido. */}
        <div style={{ fontSize: 18, fontWeight: 700, color: "#111827", lineHeight: 1.2 }}>
          {dineroDisabledMask(precioPrincipal)}
          <EtiquetaMoneda moneda={moneda} />
        </div>
        <div style={{ fontSize: 11, color: "#6b7280", marginTop: 2 }}>
          neto {dineroDisabledMask(netoPrincipal)}
        </div>

        <div
          style={{
            marginTop: 8,
            paddingTop: 6,
            borderTop: "1px dashed #f3f4f6",
            fontSize: 11,
            color: "#9ca3af",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 6,
          }}
        >
          {sinConfigurar ? (
            <span style={{ fontStyle: "italic" }}>Sin precio configurado</span>
          ) : (
            <span>
              s/costo {dineroDisabledMask(sugerido)}
              {desfasado ? (
                <strong style={{ color: "#b45309", marginLeft: 4 }}>
                  {diferencia > 0 ? "+" : "−"}
                  {dineroDisabledMask(Math.abs(diferencia))}
                </strong>
              ) : (
                <span style={{ marginLeft: 4 }}>= igual</span>
              )}
            </span>
          )}
          {(desfasado || sinConfigurar) && (
            <Tooltip title="Cargar el margen objetivo en la calculadora">
              <CalculatorOutlined
                onClick={() => onCargarSugerido(porcentajeObjetivo)}
                style={{ color: "#00BFD6", cursor: "pointer", flexShrink: 0 }}
              />
            </Tooltip>
          )}
        </div>
      </div>

      <button
        type="button"
        onClick={() => onUsar(precioPrincipal)}
        disabled={!precioPrincipal || precioPrincipal <= 0}
        style={{
          border: "none",
          borderTop: "1px solid #f3f4f6",
          background: !precioPrincipal || precioPrincipal <= 0 ? "#f5f5f5" : "#00BFD6",
          color: !precioPrincipal || precioPrincipal <= 0 ? "#9ca3af" : "#fff",
          fontWeight: 600,
          fontSize: 12,
          padding: "7px 0",
          cursor: !precioPrincipal || precioPrincipal <= 0 ? "not-allowed" : "pointer",
        }}
      >
        Usar
      </button>
    </div>
  );
};

export default TarjetaPrecio;
